import React, { useEffect } from 'react';
import Routes from './Routes';
import Login from './pages/login/Login';
import OAuthLogin from './pages/oauth-login/OAuthLogin';
import AuthValidate from './pages/auth-validate/AuthValidate';
import CreatePassword from './pages/create-password/CreatePassword';
import RecoveryPassword from './pages/recovery-password/RecoveryPassword';
import ProtectedRoute from './components/ProtectedRoute';
import { Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PageMaintenance from './pages/MaintenancePage';
import FireInsuranceBudgetIframe from './pages/iframe/fire-insurance-budget';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles';
import { initializeGA } from './services/analytics';

const App = () => {
  useEffect(() => {
    initializeGA();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <meta name="google" content="notranslate" />
      </Helmet>
      <Route path="/" exact component={Login} />
      <Route path="/login" component={OAuthLogin} />
      <Route path="/auth-validate" component={AuthValidate} />
      <Route path="/create-password" component={CreatePassword} />
      <Route path="/recovery-password" component={RecoveryPassword} />
      <Route path={`/manutencao`} component={PageMaintenance} />
      <Route path="/iframe/fire-insurance-budget" component={FireInsuranceBudgetIframe} />
      <ProtectedRoute path="/admin" component={Routes} />
    </ThemeProvider>
  );
};

export default App;
